import Logo from '@/components/common/Logo';
import Icon from '@/components/ui/AppIcon';

interface FooterSectionProps {
  onPrivacyClick: () => void;
  onDisclaimerClick: () => void;
}

const FooterSection = ({ onPrivacyClick, onDisclaimerClick }: FooterSectionProps) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-surface border-t border-border py-12 md:py-16 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-8">
          {/* Brand Column */}
          <div>
            <Logo size="md" linkTo="/landing-page" />
            <p className="mt-4 text-text-secondary leading-relaxed">
              AI-powered wellness coaching for sustainable healthy lifestyle transformations.
            </p>
          </div>

          {/* Quick Links Column */}
          <div>
            <h3 className="text-lg font-semibold text-text-primary mb-4">
              Quick Links
            </h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={onPrivacyClick}
                  className="text-text-secondary hover:text-primary transition-smooth focus-ring rounded"
                >
                  Privacy Policy
                </button>
              </li>
              <li>
                <button
                  onClick={onDisclaimerClick}
                  className="text-text-secondary hover:text-primary transition-smooth focus-ring rounded"
                >
                  Wellness Disclaimer
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="text-lg font-semibold text-text-primary mb-4">
              Connect With Us
            </h3>
            <div className="flex gap-4">
              <a
                href="#"
                className="w-10 h-10 bg-muted rounded-lg flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-smooth focus-ring"
                aria-label="Facebook"
              >
                <Icon name="ChatBubbleLeftIcon" size={20} />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-muted rounded-lg flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-smooth focus-ring"
                aria-label="Twitter"
              >
                <Icon name="ChatBubbleLeftIcon" size={20} />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-muted rounded-lg flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-smooth focus-ring"
                aria-label="Instagram"
              >
                <Icon name="ChatBubbleLeftIcon" size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-text-secondary">
              &copy; {currentYear} LivsmartCoach. All rights reserved.
            </p>
            <p className="text-sm text-text-secondary">
              AI-powered wellness guidance • Not medical advice
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;